export default __webpack_public_path__ + "grid-section.png";